/**
 * Assistente do sistema.
 *
 * Reexportado por `../resources.ts`. Ver docs/FRONTEND.md, secao 3.
 */

import { api } from '../client';

export type AssistantMode = 'motor' | 'base';

export interface AssistantStatus {
  engine_connected: boolean;
  mode: AssistantMode;
}

export interface AssistantMessage {
  author: 'usuario' | 'assistente';
  text: string;
}

export interface AssistantReply {
  text: string;
  mode: AssistantMode;
  sources: { id: string; title: string; route?: string }[];
}

export const assistant = {
  status: (signal?: AbortSignal) =>
    api.get<AssistantStatus>('/api/v1/assistant', signal),
  send: (input: { messages: AssistantMessage[]; screen: string }) =>
    api.post<AssistantReply>('/api/v1/assistant/messages', input),
};
